import AuthPage from '@/modules/auth/auth-page';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

const searchSchema = z.object({
  refreshToken: z.string().optional(),
  accessToken: z.string().optional()
});

export const Route = createFileRoute('/auth/')({
  component: RouteComponent,
  validateSearch: (search) => searchSchema.parse(search)
});

function RouteComponent() {
  const { accessToken, refreshToken } = Route.useSearch();
  const router = useRouter();

  useEffect(() => {
    if (accessToken && refreshToken) {
      window.store.set('access_token', accessToken);
      window.store.set('refresh_token', refreshToken);
      router.navigate({ to: '/dashboard' });
    }
  }, [accessToken, refreshToken]);

  return <AuthPage />;
}
